var site = site || {};
site.CircleGraphic = (() => {
    // Functions
    const toggleGraphic = () => { 
        const areas = document.querySelectorAll('map[name="image-map"] area');
        const overlays = document.querySelectorAll('.circle-overlay');

        areas.forEach((area, index) => {
            area.addEventListener('click', function(event) {
                event.preventDefault();

                overlays.forEach((overlay) => {
                    overlay.classList.add('d-none');
                    overlay.classList.remove('d-block');
                });

                overlays[index].classList.add('d-block');
                overlays[index].classList.remove('d-none');
            });
        });
    }

    return {
        toggleGraphic : toggleGraphic
    };
})();